const storeBreadcrumbData = () => {
  let isSubCollection;

  const breadcrumbData = JSON.parse(sessionStorage.getItem('breadcrumbs')) || [];

  if (window.theme.template.name === 'collection') {
    const lastSubCollectionsJSON = JSON.parse(sessionStorage.getItem('subCollections')) || [];
    isSubCollection = lastSubCollectionsJSON.some((item) => item.url === window.theme.template.url);
  } else if (window.theme.template.name === 'product') {
    const collectionsData = breadcrumbData.filter((item) => item.name === 'collection');
    if (collectionsData.length > 0) {
      const lastCollectionUrl = collectionsData[collectionsData.length - 1].url;
      const productCollections = theme.template.collections;
      if (productCollections.length > 0) {
        isSubCollection = productCollections.some((item) => item.url === lastCollectionUrl);
      }
    }
  }

  const currentBreadcrumb = {
    title: window.theme.template.title,
    url: window.theme.template.url,
    name: window.theme.template.name,
  };

  const existingBreadcrumbIndex = breadcrumbData.findIndex((crumb) => crumb.url === currentBreadcrumb.url);
  if (existingBreadcrumbIndex !== -1) {
    breadcrumbData.splice(existingBreadcrumbIndex);
  } else {
    if (isSubCollection) {
      if (breadcrumbData.length > 0) {
        if (breadcrumbData[breadcrumbData.length - 1].name === 'product') {
          breadcrumbData.splice(breadcrumbData.length - 1);
        }
      }
    } else {
      breadcrumbData.splice(0);
    }
  }

  breadcrumbData.push(currentBreadcrumb);
  sessionStorage.setItem('breadcrumbs', JSON.stringify(breadcrumbData));

  // Set sessionStorage with subcollections
  if (window.theme.template.name === 'collection') {
    const subCollectionsEL = document.getElementById(`SubCollectionsJSON-${window.theme.template.id}`);
    if (subCollectionsEL) {
      const subCollections = subCollectionsEL.textContent;
      sessionStorage.setItem('subCollections', subCollections);
    } else {
      sessionStorage.removeItem('subCollections');
    }
  }
};

const renderBreadcrumbs = () => {
  const maxBreadcrumbs = 4;
  let breadcrumbData = sessionStorage.getItem('breadcrumbs');

  if (breadcrumbData) {
    breadcrumbData = JSON.parse(breadcrumbData);

    const breadcrumbList = document.querySelector('.breadcrumb__list');
    if (breadcrumbList) breadcrumbList.innerHTML = '';

    // only render last maxBreadcrumbs
    const lastFourBreadcrumbData = breadcrumbData.slice(0 - maxBreadcrumbs);

    lastFourBreadcrumbData.forEach((crumb, index) => {
      const listItem = document.createElement('li');
      listItem.className = `breadcrumb__item ${index === breadcrumbData.length - 1 ? 'breadcrumb__item--active' : ''}`;

      if (index === breadcrumbData.length - 1) {
        listItem.innerHTML = `<span>${crumb.title}</span>`;
      } else {
        listItem.innerHTML = `<a href="${crumb.url}">${crumb.title}</a>`;
      }

      if (breadcrumbList) breadcrumbList.appendChild(listItem);
    });
  }
};

if (window.theme.template.name === 'product' || window.theme.template.name === 'collection') {
  storeBreadcrumbData();
}

document.addEventListener('DOMContentLoaded', renderBreadcrumbs);
